import React from 'react'
import './PreCheckTeacherModal.scss'

import StudentInstruction from './StudentInstruction'

export default function PreCheckTeacherModal(props) {

  const { StudentView, handleRetry, setInTroubleshootView } = props

  return (
    <div className='ready-module-teacher-modal'>
      <div className='__student-content'>
        <StudentInstruction>
          { StudentView && <StudentView/> }
          { handleRetry && <button onClick={handleRetry}>Try Again?</button> }
          <button 
            className='teacher-troubleshoot-button' 
            onClick={()=>{setInTroubleshootView(true)}}>
              Teacher Troubleshoot
          </button>
        </StudentInstruction>
      </div>
    </div>
  )
}